import { render, staticRenderFns } from "./bfchoicequestion.vue?vue&type=template&id=7a4c1e1b&scoped=true&"
import script from "./bfchoicequestion.vue?vue&type=script&lang=js&"
export * from "./bfchoicequestion.vue?vue&type=script&lang=js&"
import style0 from "./bfchoicequestion.vue?vue&type=style&index=0&id=7a4c1e1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4c1e1b",
  null
  
)

export default component.exports